import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

export type ContactInfoState = {
  state: string
  city: string
  postalCode: string
  addressNumber: string
  addressText: string
  ssn: string
  employmentStatus: string
  occupation: string
}

const initialState: ContactInfoState = {
  state: "",
  city: "",
  postalCode: "",
  addressNumber: "",
  addressText: "",
  ssn: "",
  employmentStatus: "",
  occupation: "",
}

const contactInfoSlice = createSlice({
  name: "contactInfo",
  initialState,
  reducers: {
    updateContactInfo: (state, { payload }: PayloadAction<Partial<ContactInfoState>>) => {
      return {
        ...state,
        ...payload,
      }
    },

    setState: (state, { payload }: PayloadAction<string>) => {
      state.state = payload
    },

    setCity: (state, { payload }: PayloadAction<string>) => {
      state.city = payload
    },

    setPostalCode: (state, { payload }: PayloadAction<string>) => {
      state.postalCode = payload
    },

    setAddressNumber: (state, { payload }: PayloadAction<string>) => {
      state.addressNumber = payload
    },

    setAddressText: (state, { payload }: PayloadAction<string>) => {
      state.addressText = payload
    },

    setSsn: (state, { payload }: PayloadAction<string>) => {
      state.ssn = payload
    },

    clearContactInfo: () => {
      return initialState
    },
  },
})

export const {
  updateContactInfo,
  setState,
  setCity,
  setPostalCode,
  setAddressNumber,
  setAddressText,
  setSsn,
  clearContactInfo,
} = contactInfoSlice.actions

export default contactInfoSlice.reducer
